import * as React from 'react';
import {IAppContext} from "../interfaces/context.interfaces";

const AppContext = React.createContext({} as IAppContext);

export default AppContext;
